{
  "zh-TW": {
    "texts": {
      "index": "Your database for all information around Ships and Stations in Star Citizen.",
      "indexQuote": "“Strap into one of dozens of ships and embark on a life within the Star Citizen universe.<br>Unbound by profession or skill sets, you choose the path of your own life.”",
      "indexQuoteSource": "Author Unknown, Source:",
      "support": {
        "info": "不方便贊助？<a href=\"https://robertsspaceindustries.com/spectrum/community/SC/forum/57219/thread/fleetyards-net\" target=\"_blank\" rel=\"noopener\"><b>在 Spectrum 為我們按讚</b></a>，讓更多人發現 FleetYards。",
        "goal": "用於伺服器託管與資料服務等日常營運開支。",
        "code": "剛接觸星際公民？使用此邀請碼可獲得 5000 UEC 初始資金：",
        "thisMonth": "本月目標 %{goal}",
        "subline": "直接支持我們",
        "otherWays": "其他協助方式"
      },
      "installApp": {
        "eventSignup": "將 FleetYards 安裝為應用程式，一鍵回到你的活動。",
        "iosIntro": "在 iPhone 和 iPad 上，可以透過分享選單安裝 FleetYards 這類應用程式：",
        "iosShare": "點一下瀏覽器工具列中的「分享」按鈕。",
        "iosAdd": "選擇「加入主畫面」，可能需要向下捲動才能找到。",
        "iosConfirm": "點一下「新增」。現在可以像其他應用程式一樣從主畫面開啟 FleetYards。"
      },
      "supportHint": {
        "hangarSync": "背景同步是我們託管帳單中最大的一項支出。FleetYards 仰賴捐款運作 — 任何支持都很重要。",
        "vehicleAdded": "FleetYards 免費、無廣告,完全靠捐款運作。如果它對你有幫助,一份小小的捐助就能維持它的運轉。",
        "fleetCreated": "艦隊是我們最耗資源的功能之一。FleetYards 因為捐款而保持免費和無廣告 — 歡迎你一起支持。",
        "loginMilestone": "你已經陪伴我們一段時間了 — 謝謝。FleetYards 仰賴捐款運作;如果你願意一起分攤費用,這裡有更多資訊。",
        "visitMilestone": "FleetYards 由社群資助 — 沒有廣告,沒有付費牆。如果你覺得它有用,一份小小的捐款就能發揮很大作用。"
      },
      "notFound": "You are currently venturing unknown space. In the event you are lost, the UEE highly recommends plotting a new destination back towards home-space.",
      "forbidden": "你的權限不包含此區域。如果某項功能仍在灰度發布中，等它對你開放後，可以在「設定 > 功能」中自行開啟。",
      "subscriptionRequired": "合約、活動、Logistics 和行程由支持 FleetYards 的人共同維持。該艦隊目前未在涵蓋範圍內 — 任何一位成員的捐助都會為整個艦隊開啟這四項功能。",
      "featureNotReady": "此功能尚未完成，即將推出。敬請期待！",
      "inviteInvalid": "此邀請連結無效。可能是輸入有誤、已過期，或已達到使用次數上限。請向邀請你的人索取新的連結。",
      "accessDenied": "您無權檢視此頁面。",
      "serverError": "伺服器目前遇到技術問題。請稍後再試。",
      "offline": "請求未能送達伺服器。你的裝置似乎已離線，或者無法連線到伺服器。請檢查網路連線後再試一次。",
      "invalidRequest": "伺服器無法處理此請求。請重新整理頁面後再試一次。",
      "invalidListRequest": "此篩選器或排序無效。請重置後重新顯示列表。",
      "compare": {
        "ships": {
          "info": "To start select at least two and not more than eight Ships you want to compare."
        }
      },
      "fleets": {
        "leaveInfo": "You can not leave a Fleet as an Admin."
      },
      "admin": {
        "destroyedFleets": {
          "purgedWarning": "還原已清除的艦隊只能盡力而為。角色、圖片、邀請連結與艦隊載具不會被還原。"
        },
        "models": {
          "viewsFolder": {
            "hint": "拖入一個資料夾，內含名為 top.png、side.png、front.png 與 angled.png 的檢視圖。彩繪版本加上 _colored 後綴，展開版本加上 extended_ 前綴，著陸版本加上 landed_ 前綴。flight_ 前綴或不加前綴都會歸入預設組。holo.gltf 也會一併處理，前綴規則相同。",
            "uploading": {
              "one": "正在上傳一個檔案…",
              "other": "正在上傳 %{count} 個檔案…"
            },
            "matched": {
              "one": "一個檔案已就緒 — 儲存即可套用。",
              "other": "%{count} 個檔案已就緒 — 儲存即可套用。"
            },
            "ignored": "已忽略：%{files}"
          }
        },
        "oauthApplications": {
          "rejectHint": "此原因會顯示給註冊此應用程式的人，請說明需要修改什麼。"
        }
      },
      "hangarGuide": {
        "add": "To add a new ship to your hangar visit the ships page and click on the bookmark icon in the top right corner of the ship you want to add.<br>Alternatively you can add a ship on its detail page, the button is located on the right side below the stats boxes.<br>You can click multiple times on the icon if you want more than one ship of the same type.",
        "edit": "To edit a ship just click on the pencil icon in the top right corner of the ship you want to edit.",
        "wishlist": "To add a new ship to your wishlist visit the ships page and click on the bookmark icon in the top right corner of the ship you want to add.<br>Alternatively you can add a ship on its detail page, the button is located on the right side below the stats boxes.",
        "groups": {
          "add": "To add a group just click on the plus icon in the line prefixed by \"groups\".",
          "edit": "To edit a group make a right click on the group you want to edit."
        },
        "fleetchart": "To view a scaled fleetchart of your ships from an above view angle just click on the \"Fleetchart\" button over your ship list.<br>In the fleetchart mode you can scale the ships.<br>To save a transparent png of your fleetchart please visit the public page of your hangar.",
        "public": "Your hangar has a public visible page where all ships are listed. You can access your public hangar by clicking on the \"Public URL\" button in the top right corner.",
        "icon": "注意這個圖示："
      },
      "hangarPreview": {
        "notified": {
          "headline": "取得新飛船和促銷通知",
          "text": "Get notified once a new Ship is released on <a href=\"https://robertsspaceindustries.com\" target=\"_blank\" rel=\"noopener\">robertsspaceindustries.com</a> and never miss a Sale. You can also enable Sale Notifications for Ships in your Hangar."
        },
        "manage": {
          "headline": "管理您的機庫",
          "text": "Add Ships to your Hangar, name your Ships, mark them as wanted or get notified if a Ship gets on Sale. Decide which Ship you want to show on your Public Hangar. Get further Insights into your Hangar: Which Roles can your Ships fulfil? How many Ships are Flight Ready? What is your main Manufacturer? How much money did you spend?"
        },
        "fleetchart": {
          "headline": "艦隊圖表和公開機庫",
          "text": "View your Ships as a scaled topview Fleetchart and export it as an image. Get a Public Hangar page which you can share with others, you decide what Ships will be visible on your Public Hangar."
        }
      },
      "fleetPreview": {
        "notified": {
          "headline": "分析",
          "text": "View stats of your Fleet - analyze and optimize for roles, cargo capacity etc."
        },
        "overview": {
          "headline": "概覽與管理",
          "text": "Invite your Org Mates and get a filterable and searchable list of all public Ships. "
        },
        "fleetchart": {
          "headline": "艦隊圖表",
          "text": "View your Fleet as a scaled topview Fleetchart and export it as an image."
        }
      },
      "impressum": {
        "visit": "訪問",
        "ytShipImages": "The Awesome Ship Images in the Hangar Fleetchart view are the work of <a href=\"https://twitter.com/WhyTeeZero\" target=\"_blank\" rel=\"noopener\">YT (Twitter: @WhyTeeZero)</a>.<br>Please visit his Spectrum post (see links below) and give him a upvote.",
        "erkul": "The ship metrics on Fleetyards are modelled on the formulas and readouts of Erkul's DPS Calculator. Thanks to the erkul.games team for sharing their work with the community.",
        "appSignal": "AppSignal provided a sponsored Open Source Account which helps to improve Fleetyards.net even further. Thanks :)",
        "copyright": "The contents and works created by the page operators, on these pages are subject to German copyright. Duplication, processing, distribution and any kind of exploitation outside the limits of Copyright require the written consent of the respective author or creator. Downloads and copies of this page are only for private, non-commercial use. Insofar as the content on This page was not created by the operator, are third-party copyrights respected. In particular, Third-party content as such. Please Contact us if you notice any sort of copyright infringement. We will remove any content immediately as we become aware of such violations.",
        "disclaimer": {
          "p1": "This is an unofficial Star Citizen fansite, not affiliated with the Cloud Imperium group of companies.",
          "p2": "All content on this site not authored by its host or users are property of their respective owners.",
          "p3": "Star Citizen®, Squadron 42®, Roberts Space Industries®, and Cloud Imperium® are registered trademarks of Cloud Imperium Rights LLC. All rights reserved."
        },
        "liabilityInternal": {
          "p1": "The content of out site has been compiled with meticulous care and to the best of our knowledge. However, We cannot assume any liability for the up-to-dateness, completeness or accuracy of any of the pages.",
          "p2": "Pursuant to section 7, para. 1 of the TMG (Telemediengesetz), We are liable for our own content on these pages in accordance with general laws. However, pursuant to sections 8 to 10 of the TMG, We are not under obligation to monitor external information provided or stored on our site. Once We have become aware of a specific infringement of the law, We will immediately remove the content in question. Any liability concerning this matter can only be assumed from the point in time at which the infringement becomes known to us."
        },
        "liabilityExternal": "Our site contains links to websites of third parties (“external links”). As the content of these sites is not under our control, We cannot assume any liability for such external content. In all cases, the provider of information of the linked sites is liable for the content and accuracy of the information provided. At the point in time when the links were placed, no infringements of the law were recognisable to us. As soon as an infringement of the law becomes known to us, We will immediately remove the link in question."
      },
      "privacy": {
        "text": "The use of our site is usually possible without providing any personal data. The collecting of personal data (eg email address) on our sites will be, as far as possible, on a voluntary basis. No personal data will be passed on to third parties without your explicit consent.<br>We point out that data transmission over the Internet (eg when communicating by email) can have security gaps. A complete protection of data against access by third parties is not possible.",
        "p1": "Below you can read about what Information we are using to provide you the services on %{app}. For most parts this only concerns registered Users but please read further to get a full overview.",
        "p2": {
          "headline": "我們使用哪些資訊?",
          "text": "Depending on if you are a registered User or only using %{app} as a Guest we use more or less Information from you."
        },
        "p3": {
          "headline": "作為訪客",
          "text": "作為 %{app} 的訪客，我們收集以下資料："
        },
        "analytics": {
          "headline": "使用分析",
          "basis": "%{app} 會統計頁面瀏覽次數，以了解網站的哪些部分實際被使用。這是基於我們經營與改善網站的正當利益，而非基於同意：資料僅由我們第一方收集，IP 位址在儲存前已匿名化，不會在您的裝置上放置 Cookie 或其他識別碼，也不會與任何廣告聯播網分享。",
          "retention": "個別的造訪與頁面瀏覽紀錄會在一個月後刪除。之後僅保留無法追溯到個人的彙總數據。刪除您的帳戶時，也會一併刪除為其記錄的造訪資料。",
          "objection": {
            "headline": "如何表示反對",
            "text": "您可以隨時反對使用分析，我們會停止記錄，而不只是將資料隱藏起來。",
            "user": "您在設定中的帳戶選項會套用到您登入的每一台裝置。",
            "guest": "沒有帳戶時，您可以在此表示反對。若您的瀏覽器傳送 Global Privacy Control 訊號，我們也會予以尊重。"
          }
        }
      },
      "settings": {
        "privacy": {
          "tracking": "啟用後，我們會統計您造訪的頁面，以了解網站的哪些部分被使用。IP 位址會匿名化，不會在您的裝置上儲存任何資料，個別造訪紀錄會在一個月後刪除。關閉後將完全停止記錄。",
          "onlineStatus": "啟用後，只要你開著 FleetYards，你所屬艦隊的成員與你的好友就會在你的名字旁看到一個圓點。關閉後他們將看不到它——其他內容不變，你的最近活動時間仍會顯示。"
        },
        "notifications": {
          "hint": "選擇每種事件要如何通知您。App 通知會收集在您的通知中心，郵件則寄到您帳戶的電子郵件地址。"
        }
      },
      "signup": {
        "blocked": "You have been blocked from FleetYards.net.<br>This can have multiple Reasons.<br>For further Information please Contact us under info ( at ) fleetyards.net"
      },
      "roadmap": {
        "inactive": "This Item was removed from the Roadmap. This is its last location"
      },
      "twoFactor": {
        "backupCodes": "Save a copy of your Backup-Codes. They will only be visible this one time.",
        "disable": "要停用兩步驟驗證，只需輸入一個有效的權杖。",
        "enable": " To secure your FleetYards.net Account you can generate 2-Factor-Auth Tokens with Google Authenticator, 1Password or Authy."
      },
      "oauthAuthorize": {
        "requestingAccess": "%{clientName} 正在請求存取您的帳戶。",
        "scopesIntro": "此應用程式將能夠："
      },
      "syncExtension": {
        "gettingStarted": "To sync your RSI Hangar with Fleetyards you first need to install the Fleetyards Sync Extension for Firefox or Chromium based Browsers.",
        "info": "We will try to match the ships from your RSI Hangar with your existing ships in your Fleetyards Hangar by using the name and the pledge-id. Ships from the RSI Hangar without a match will be added to your Fleetyards Hangar.<br><br>Do you want to continue?",
        "alreadyRunning": "機庫同步已在進行中。請等待完成。"
      },
      "setEmail": "要設定密碼、啟用雙重認證或接收郵件通知，您需要為帳戶添加電子郵件地址。您將收到一封確認郵件來驗證該地址。",
      "oauthApplications": {
        "pendingReview": "此應用程式已註冊，正在等待審核。在獲得核准前無法請求存取權限。",
        "rejected": "此應用程式已被拒絕，無法請求存取權限。依照原因所述修改後會重新進入審核佇列。",
        "returnedToReview": "修改重新導向 URI 或權限範圍會使已核准的應用程式重新進入審核。"
      },
      "payouts": {
        "tourInvite": "%{username} 邀請你加入此行程。",
        "contractReady": "合約已完成。開啟分帳帳本，將報酬支付給承接人。",
        "contractNotReady": "此合約尚未開啟分帳帳本。",
        "expenseNeedsReview": "支出需經帳本管理者核准後才會計入。"
      },
      "fleet": {
        "contractCovers": "合約板為每種合約顯示的圖片。留空則使用下方的內建圖片。"
      }
    }
  }
}
